<div class="promotion">
    <dr-card [padding]="'none'" [appearance]="'outlined'" class="promotion__card">
        <!-- Video player -->
        <dr-video-player
            class="promotion__player"
            [videoUrl]="config.videoUrl"
            [title]="config.videoTitle || DEFAULT_VIDEO_TITLE"
        ></dr-video-player>

        <!-- Text + CTA -->
        <div class="promotion__content">
            <h1 class="promotion__title">{{ config.title }}</h1>
            <p class="promotion__subtitle">
                {{ config.subtitle }}
                <a
                    *ngIf="config.learnMoreUrl"
                    class="promotion__subtitle__learn-more"
                    [href]="config.learnMoreUrl"
                    target="_blank"
                    rel="noopener noreferrer"
                    >Learn more</a
                >
            </p>

            <div class="promotion__content__buttons">
                <dr-button [theme]="'primary'" [type]="'button'" (click)="handleCtaClick()">
                    Meet our expert
                </dr-button>
                <dr-button *ngIf="isConnectorRoute" [theme]="'ghost'" [type]="'button'" (click)="goToAgentsLite()">
                    Go to FinanceOS Agents Lite
                </dr-button>
            </div>
        </div>
    </dr-card>
</div>
